

import Vue, { VNode } from "vue";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { mapGetters } from "vuex";
import { patchDirectSelect } from "../draw/RouteMode"

import theme from "../draw/theme";

export default Vue.extend({
	
	render: () => null as unknown as VNode,
	inject: ["$map"],

	mounted() {
		const modes = MapboxDraw.modes;
		let patched = {
			...modes,
			direct_select: patchDirectSelect(modes.direct_select)
		}

		var draw = new MapboxDraw({
			modes:patched,
			clickBuffer: 4,
			styles: theme,
			controls: {
				trash: true,
				point:false,
				line_string:false,
				polygon:false,
				combine_features: false,
				uncombine_features: false,
			}
		});
		this.$map.addControl(draw);
		this["draw"] = draw;

		const [id] = draw.add(this.drawFeature);
		draw.changeMode("direct_select", {featureId:id})

		this.$map.on("draw.update", async evt => {

			let coords = evt.features[0].geometry.coordinates;
			this.$store.dispatch("patchRoute", coords);
			

		});
	},

	methods: {
	},

	computed: {
		...mapGetters(["drawFeature"])
	},

	watch: {
		drawFeature() {
			this["draw"].add(this.drawFeature);
		}
	}
})
